import { resolveExchangeRequestId } from "./filterUtils";

export interface ExchangeSnapshot {
  row: Record<string, unknown>;
  creationDateMs: number;
}

export const resolveCreationDateMs = (row: unknown): number => {
  if (!row || typeof row !== "object") {
    return 0;
  }
  const record = row as Record<string, unknown>;
  const raw = record.CreationDate ?? record.creationDate;
  if (raw == null || raw === "") {
    return 0;
  }
  const ms = Date.parse(String(raw));
  return Number.isFinite(ms) ? ms : 0;
};

/**
 * Keep the newest row per `ExchangeRequestId` (matches `pbhorders` one-row-per-exchange
 * semantics). OData chunks are sorted `CreationDate desc`, but we compare timestamps
 * so out-of-order chunks still resolve correctly.
 */
export const mergeLatestExchangeSnapshots = (
  snapshots: Map<string, ExchangeSnapshot>,
  rows: unknown[],
): void => {
  for (const row of rows) {
    if (!row || typeof row !== "object") {
      continue;
    }
    const record = row as Record<string, unknown>;
    const exchangeId = resolveExchangeRequestId(record);
    const creationDateMs = resolveCreationDateMs(record);
    if (exchangeId == null) {
      continue;
    }
    const key = String(exchangeId);
    const existing = snapshots.get(key);
    if (!existing || creationDateMs >= existing.creationDateMs) {
      snapshots.set(key, { row: record, creationDateMs });
    }
  }
};

/** Newest-first list of snapshot rows for client action refinement. */
export const snapshotsToSortedRows = (
  snapshots: Map<string, ExchangeSnapshot>,
): Record<string, unknown>[] =>
  Array.from(snapshots.values())
    .sort((a, b) => b.creationDateMs - a.creationDateMs)
    .map((entry) => entry.row);
